var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOmniflowWhiteSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 161,
    viewBox: "0 0 157 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.43 112.12C120.43 116.63 116.78 120.28 112.27 120.28C107.76 120.28 104.11 116.63 104.11 112.12V48.73C104.11 39.26 101.93 30.87 97.5702 23.58C93.2102 16.28 87.0802 10.53 79.1802 6.32C71.2802 2.11 62.3702 0 52.4502 0C42.5302 0 33.2802 2.07 25.6102 6.2C17.9402 10.33 11.9602 16.05 7.67023 23.34C3.38023 30.63 1.24023 39.09 1.24023 48.72V112.11H35.9802V49.17C35.9802 43.45 37.4502 38.94 40.3802 35.64C43.3102 32.33 47.3402 30.68 52.4502 30.68C55.9102 30.68 58.9202 31.43 61.4702 32.94C64.0302 34.44 65.9802 36.59 67.3302 39.37C68.6802 42.15 69.3602 45.42 69.3602 49.18V112.11C69.3602 135.81 88.5702 155.01 112.26 155.01C135.95 155.01 155.16 135.8 155.16 112.11V48.57H120.42V112.11L120.43 112.12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.68 37.2298C147.958 37.2298 156.29 28.8978 156.29 18.6198C156.29 8.34175 147.958 0.00976562 137.68 0.00976562C127.402 0.00976562 119.07 8.34175 119.07 18.6198C119.07 28.8978 127.402 37.2298 137.68 37.2298Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.61 160.7C28.888 160.7 37.22 152.368 37.22 142.09C37.22 131.812 28.888 123.48 18.61 123.48C8.33198 123.48 0 131.812 0 142.09C0 152.368 8.33198 160.7 18.61 160.7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmniflowWhiteSmall);
export default __webpack_public_path__ + "static/media/omniflow-white-small.136d4bf91c59b12440bdf95138ccfdf1.svg";
export { ForwardRef as ReactComponent };